import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import { PopOut, TextField, Tooltip } from 'components';
import { FaPlus, FaRegQuestionCircle } from 'react-icons/fa';
import Options from './Options';
import OptionBlock from './OptionBlock';
import OptionTag from './OptionTag';

const defaultStyle = {
    backgroundColor: 'var(--primary-colr)',
    margin: '0.5rem 0 0 0',
}

const Container = styled.div`
    box-sizing: border-box;
    background-color: ${props => props.styles.backgroundColor};
    border-radius: 5px;
    box-shadow: var(--box-shadow);
    cursor: pointer;
    margin: ${props => props.styles.margin};
    border-style: solid;
    border-width: 2px;
    padding: 0.25rem 0.5rem;
    border-color: ${props => props.error ? 'var(--error-color)' : 'transparent'};
    overflow: hidden;
    :hover {
        filter: brightness(var(--brightness));
    }
`

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) min-content;
    align-items: center;
`

const Label = styled.div`
    font-size: 0.8rem;
    font-weight: bold;
    margin: 0 0 0.2rem 0;
`

const Error = styled.div`
    font-size: 0.8rem;
    color: var(--error-color);
    margin-left: 0.2rem;
    :before {
        content: '*'
    }
`

const Column = styled.div`
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`

const Row = styled.div`
    display: flex;
    align-items: center;
`

const TagContainer = styled.div`
    min-height: 1rem;
    display: flex;
    flex-direction: row;
    /* flex-wrap: wrap; */
    /* overflow-x: auto; */
    min-height: 1.5rem;
    width: max-content;
`

const InputContainer = styled.div`
    min-height: 1rem;
    min-width: 5rem;
    width: ${props => `${props.width}px` || '100%'};
    max-width: ${props => `${props.width}px` || '100%'};
    background-color: var(--secondary-color);
    box-shadow: var(--box-shadow);
    margin: 1rem 0 0 0;
    padding: 0.5rem;
    border-radius: 5px;
    border: 1px solid var(--secondary-color);
    display: flex;
    flex-direction: column;
`

const TextInputContainer = styled.div`
    border-radius: 5px;
    background-color: var(--primary-color);
    padding: 0.25rem 0.5rem;
    margin: 0 0 0.5rem 0;
    box-shadow: var(--box-shadow);
`

const TagInputContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    border-radius: 5px;
    overflow: hidden;
`

const Placeholder = styled.div`
    font-size: 0.8rem;
    padding: 0 0.25rem;
    color: ${props => props.error && 'var(--error-color)'};
`

const MultiSelector = props => {
    const {
        label,
        selected,
        options,
        onSelect,
        error,
        styles,
        helper
    } = props;
    const updatedStyle = Object.assign({}, defaultStyle, styles)
    const [open, setOpen] = useState(false)
    const [input, setInput] = useState(null)
    const [width, setWidth] = useState(null)
    const ref = React.createRef()
    useEffect(() => {
        setWidth(ref.current.getBoundingClientRect()['width']+5)
        // console.log('new width', ref.current.getBoundingClientRect()['width']+5)
    }, [])

    ////////////
    // STYLES //
    ////////////
    const tileStyle = {
        backgroundColor: 'var(--primary-color)'
    }
    const tileOptionStyle = {
        boxShadowColor: 'transparent', 
        color:'var(--primary-accent-color)', 
        backgroundColor:'var(--primary-color)', 
        placement:'bottom', 
        hoverColor:'var(--text-color)', 
        margin:'0rem', padding:'0.2rem', fontSize:'0.7rem'
    }

    ///////////////
    // UTILITIES //
    ///////////////
    const onKeyPress = (event) => {
        switch(event.charCode){
            case 13:
                let updatedTags = [...selected]
                updatedTags.push(event.target.value)
                onSelect(updatedTags) 
                setInput('')
                console.log(input, 'Enter')
                break
            case 27:
                console.log(input, 'Esc')
                break
        }
    }

    const getOptions = () => {
        const textInput = <TextInputContainer>
                            <TextField type='single' style={{width: '100%'}} size={1} mantainFocus focus
                                            value={input}
                                            onChange={(event) => setInput(event.target.value)} 
                                            onKeyPress={onKeyPress}/>
                            </TextInputContainer>
        const selectedTags = selected ? selected.map(v => <OptionTag option={v} onDelete={removeTag}/>) : []
        let tagBlock = selectedTags.length === 0 ? <Placeholder>No tags selected</Placeholder> 
                    : <TagInputContainer>{selectedTags}</TagInputContainer>
        return <InputContainer width={width}>
                    {textInput}
                    {tagBlock}
                </InputContainer>
    }

    const removeTag = v => {
        let updatedTags = [...selected]
        updatedTags.splice(updatedTags.indexOf(v), 1)
        onSelect(updatedTags)
    }

    const getTags = () => {
        // let optionTags = selected ? selected.map(v => <OptionTag option={v} onDelete={removeTag}/>) : null
        let optionTags = selected ? selected.map(v => <OptionTag option={v} styles={{margin: '0 0.2rem 0 0'}}/>) : null
        return optionTags
    }

    const optionBlock = getOptions()
    return (
        <Container error={error} styles={updatedStyle} ref={ref}>
            <PopOut trigger='leftClick' placement='bottom' element={optionBlock} onOpen={() => setOpen(true)} onClose={() => setOpen(false)}>
                <Wrapper>
                    <Column>
                        {label && 
                        <Row>
                            <Label>{label}</Label>
                            {helper && 
                            <Tooltip title={helper}>
                                <div style={{display: 'flex', color: 'var(--secondary-accent-color)', fontSize: '0.8rem', margin: '0 0.3rem', cursor: 'pointer'}}><FaRegQuestionCircle/></div>
                            </Tooltip>}
                            {error && <Error>{error}</Error>}
                        </Row>}
                        <TagContainer>
                            {getTags()}
                        </TagContainer>
                    </Column>
                    <FaPlus style={{color: 'var(--secondary-accent-color)', fontSize: '0.8rem'}}/>
                </Wrapper>
            </PopOut>
        </Container>
    )
}

export default MultiSelector;
